import { createConsumer, type Consumer } from "@rails/actioncable"

let consumer: Consumer | null = null

export function getConsumer(): Consumer {
  if (!consumer) {
    consumer = createConsumer()
  }
  return consumer
}
